<template>
  <div class="component island-header">
    <IslandTitle>{{title}}</IslandTitle>
    <div class="title-annotation" v-if="annotation">{{annotation}}</div>
  	<slot></slot>
  </div>
</template>
 
<script>
import Vue from 'vue';
import IslandTitle from './IslandTitle.vue';

export default Vue.extend({
  name: 'IslandHeader',
  props: {
    title: String,
    annotation: String,
  },
  components: {
    IslandTitle,
  },
});
</script>

<style lang="scss">
@import "../styles/variables.scss";

.component.island-header {
  display: flex;
  align-items: center;

  .title-annotation {
    font-weight: 500;
    color: rgba(34, 34, 34, 0.5);
  }

  > .island-title + * {
    margin-left: $gutter/2;
  }

  + .table,
  + .table-wrap {
    margin-top: -$gutter/2;
  }
}

.component.island {
  .component.island-header {
    margin-bottom: $gutter;
  }
}
</style>


